import BrownianMotion from "./containers/BrownianMotion";
export default BrownianMotion;